import { Reveal, SectionLabel } from "@/components/Reveal";
import { Terminal } from "lucide-react";

const lines = [
  { p: "root@server:~$", t: "whoami" },
  { p: "", t: "richie_akpan // it_system_security_analyst" },
  { p: "root@server:~$", t: "cat mission.txt" },
  {
    p: "",
    t: "I monitor, harden, and defend IT systems — detect threats early, close gaps fast, keep the business online.",
  },
  { p: "root@server:~$", t: "cat approach.md" },
  {
    p: "",
    t: "Zero-trust by default. Assume breach. Scan, remediate, verify — until the baseline is boring.",
  },
  { p: "root@server:~$", t: "ls ~/expertise/" },
  {
    p: "",
    t: "security_operations/  vulnerability_assessment/  network_security/  azure_cloud_security/  incident_response/  grc/",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel id="SYS_01">ABOUT // TERMINAL_INIT</SectionLabel>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <div className="relative aspect-[4/5] max-w-md">
              <div className="absolute inset-0 border border-white/10 corner-bracket" />
              <img
                src="https://customer-assets.emergentagent.com/job_smooth-scroll-3d-12/artifacts/ylq1y906_IMG_5343.jpeg"
                alt="Richie Akpan"
                data-testid="about-portrait"
                className="w-full h-full object-cover"
                style={{
                  filter: "grayscale(1) contrast(1.08) brightness(0.95)",
                }}
              />
              {/* Vignette — pushes room background into shadow, keeps subject */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(ellipse 62% 68% at 50% 42%, transparent 35%, rgba(5,5,5,0.55) 75%, #050505 100%)",
                }}
              />
              {/* Color wash */}
              <div
                className="absolute inset-0 mix-blend-screen pointer-events-none"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,255,102,0.06) 0%, transparent 50%, rgba(0,240,255,0.05) 100%)",
                }}
              />
              <div className="absolute bottom-3 left-3 font-['JetBrains_Mono'] text-[10px] tracking-[0.3em] text-[#00FF66]">
                IMG_01 // OPERATOR
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={0.15}>
            <h2 className="font-['Unbounded'] font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F5F5F5] leading-[1.05]">
              Analyst <span className="text-[#A1A1AA]">by title.</span>
              <br />
              <span className="text-[#00FF66]">Operator&nbsp;</span>
              <span className="text-[#A1A1AA]">by habit.</span>
            </h2>

            <div
              data-testid="about-terminal"
              className="mt-8 border border-white/10 bg-[#0A0A0A]"
            >
              <div className="flex items-center gap-2 px-4 py-2 border-b border-white/10">
                <span className="w-2 h-2 rounded-full bg-[#FF3B30]" />
                <span className="w-2 h-2 rounded-full bg-[#F5C518]" />
                <span className="w-2 h-2 rounded-full bg-[#00FF66]" />
                <span className="ml-3 font-['JetBrains_Mono'] text-[10px] tracking-[0.3em] text-[#A1A1AA] flex items-center gap-1">
                  <Terminal size={10} strokeWidth={1.5} /> RA://SESSION_01
                </span>
              </div>
              <div className="p-5 lg:p-6 font-['JetBrains_Mono'] text-[13px] leading-relaxed">
                {lines.map((l, i) => (
                  <div key={i} className="whitespace-pre-wrap break-words">
                    {l.p && <span className="text-[#00FF66]">{l.p} </span>}
                    <span className="text-[#F5F5F5]">{l.t}</span>
                  </div>
                ))}
                <div className="mt-2">
                  <span className="text-[#00FF66]">root@server:~$ </span>
                  <span className="cursor-blink text-[#00FF66]">▮</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
